{
    "a": {
        "start": 1.107,
        "end": 1.267
    },
    "b": {
        "start": 0.472,
        "end": 0.61
    },
    "c": {
        "start": 0.556,
        "end": 0.92
    },
    "d": {
        "start": 0.7,
        "end": 0.788
    },
    "e": {
        "start": 1.241,
        "end": 1.361
    },
    "f": {
        "start": 0.266,
        "end": 0.383
    },
    "g": {
        "start": 0.477,
        "end": 0.609
    },
    "h": {
        "start": 0.509,
        "end": 0.638
    },
    "i": {
        "start": 0.635,
        "end": 0.84
    },
    "j": {
        "start": 0.386,
        "end": 0.565
    },
    "k": {
        "start": 0.19,
        "end": 0.304
    },
    "l": {
        "start": 1.469,
        "end": 1.741
    },
    "m": {
        "start": 1.126,
        "end": 1.475
    },
    "n": {
        "start": 1.094,
        "end": 1.472
    },
    "o": {
        "start": 1.477,
        "end": 1.612
    },
    "p": {
        "start": 0.486,
        "end": 0.591
    },
    "q": {
        "start": 1.472,
        "end": 1.597
    },
    "r": {
        "start": 0.29,
        "end": 0.413
    },
    "s": {
        "start": 1.267,
        "end": 1.685
    },
    "t": {
        "start": 1.217,
        "end": 1.375
    },
    "u": {
        "start": 1.088,
        "end": 1.252
    },
    "v": {
        "start": 1.217,
        "end": 1.509
    },
    "w": {
        "start": 1.044,
        "end": 1.536
    },
    "x": {
        "start": 1.387,
        "end": 1.671
    },
    "y": {
        "start": 1.296,
        "end": 1.454
    },
    "z": {
        "start": 1.267,
        "end": 1.554
    },
    "å": {
        "start": 0.392,
        "end": 0.497
    },
    "ä": {
        "start": 0.837,
        "end": 0.974
    },
    "ö": {
        "start": 1.404,
        "end": 1.574
    }
}
